export default __webpack_public_path__ + "static/button-anatomy-dark-f3e358dc958de73bc8215d7ce7e98fe7.png";